import React, { useEffect, useRef, useState } from 'react';
import InventoryPage from './InventoryPage';
import TakeInventoryModal from './TakeInventoryModal';
import AddHistoricalEntryModal from './TakeInventoryModal';
import './InventoryModal.css';

const InventoryModal = ({ isOpen, onClose, user }) => {
  const modalRef = useRef(null);
  const [showTakeModal, setShowTakeModal] = useState(false);
  const [showHistoricalModal, setShowHistoricalModal] = useState(false);
  const [lastInventoryDate, setLastInventoryDate] = useState(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'hidden';
      fetchLastInventoryDate();
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  const fetchLastInventoryDate = async () => {
    try {
      const response = await fetch('/backend/api/inventory/get-stats.php', {
        credentials: 'include'
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.success && data.current) {
          const date = new Date(data.current.snapshot_date).toLocaleDateString();
          setLastInventoryDate(date);
        }
      }
    } catch (error) {
      console.error('Error fetching last inventory date:', error);
    }
  };


  const handleModalSave = () => {
    setShowTakeModal(false);
    // The InventoryPage will refresh its data automatically
  };

  if (!isOpen) return null;

  return (
    <div className="inventory-modal-overlay">
      <div className="inventory-modal" ref={modalRef}>
        <div className="modal-header">
          <div className="header-left">
            <h2 className="modal-title">Inventory & Statistics</h2>
            {lastInventoryDate && (
              <span className="last-inventory-text">Last: {lastInventoryDate}</span>
            )}
          </div>
          <div className="header-actions">
            <button className="btn-primary" onClick={() => setShowTakeModal(true)}>
              Take Inventory
            </button>
            <button className="close-button" onClick={onClose}>×</button>
          </div>
        </div>
        <div className="modal-content">
          <InventoryPage user={user} inModal={true} />
        </div>
        
        {showTakeModal && (
          <TakeInventoryModal 
            isOpen={showTakeModal}
            onClose={() => setShowTakeModal(false)}
            onSave={handleModalSave}
          />
        )}
        
        {showHistoricalModal && (
          <AddHistoricalEntryModal 
            isOpen={showHistoricalModal}
            onClose={() => setShowHistoricalModal(false)}
            onSave={handleModalSave}
          />
        )}
      </div>
    </div>
  );
};

export default InventoryModal;
